let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("lAFGg")).then(() => parcelRequire('dZ1Na'));